import React, { FC } from 'react'
import FormattedPrice from '../../../common/formatted-price'
import { Typography } from 'react-components'
import { useTranslation } from '../../../../hooks/locale'
import { CostBar, PriceGuestWrapper, PricesRow, SlasherPrice, AvailableTag, TickIcon } from './styles'
import CheckIcon from '../../../../assets/icons/check-icon.svg'
import { AnyStyledComponent } from 'styled-components'
import { SearchbarFieldsReturn } from '../../hooks/use-searchbar'
import { calculateDateDifference } from '../../../../utils/date-utils'
import PulsatingDots from '../../pulsating-dots'
import get from 'lodash/get'
import { FormattedLivePricingDataTransport } from '../../../../models/pricing/live-pricing-formatter'
import { useABVariant } from '../../../../utils/hooks'
import { AB_KEY, AB_VARIANT_VERSION } from '../../../../common/constants'

type CostsProps = {
    pricingDetails: FormattedLivePricingDataTransport | null
    isPricingLoading: boolean
    isAvailabilityLoading: boolean
    pricingErrorCode: number | null
    searchbar: SearchbarFieldsReturn
    showVatTax: boolean
    showCalendar: boolean
    isEnquiryPopup?: boolean
}

const Costs: FC<CostsProps> = ({
    pricingDetails,
    isPricingLoading,
    isAvailabilityLoading,
    searchbar,
    showVatTax,
    showCalendar,
    isEnquiryPopup = false,
}) => {
    const { t } = useTranslation()
    const totalPersons = searchbar.adults + searchbar.kids
    const nights = calculateDateDifference(searchbar.arrival, searchbar.departure)
    const price = get(pricingDetails, 'formattedPrice')

    const priceBeforeOffer = get(pricingDetails, 'priceBeforeOffer')
    const { isProvidedVariantActive: isSlasherPriceActive } = useABVariant(AB_KEY.SLASHER_PRICE, AB_VARIANT_VERSION.ONE)

    const renderCurrentPrice = () =>
        price && (
            <Typography variant={isEnquiryPopup ? 'h6' : 'h5'} fontWeight="semiBold">
                <FormattedPrice
                    priceInBaseUnits={pricingDetails?.priceInBaseUnits}
                    currency={pricingDetails?.currency}
                    fallbackPrice={price}
                    isExpose
                />
            </Typography>
        )

    if (isPricingLoading || isAvailabilityLoading) {
        return (
            <CostBar>
                <PriceGuestWrapper>
                    <PulsatingDots />
                </PriceGuestWrapper>
            </CostBar>
        )
    }

    return (
        <CostBar isEnquiryPopup={isEnquiryPopup}>
            <PriceGuestWrapper>
                {isSlasherPriceActive && price && priceBeforeOffer ? (
                    <PricesRow>
                        <SlasherPrice>{priceBeforeOffer}</SlasherPrice>
                        {renderCurrentPrice()}
                    </PricesRow>
                ) : (
                    renderCurrentPrice()
                )}
                {!isEnquiryPopup && nights && totalPersons && (
                    <Typography variant="subtitle2" color="tfwBlack40" fontWeight={'regular'}>
                        {`${t('guestsCount', { count: totalPersons })}/${t('nightsCount', { count: nights })}`}
                    </Typography>
                )}
                {showVatTax && (
                    <Typography variant="overline" color="tfwBlack40" fontWeight={'regular'}>
                        {t('price.vatTaxInfo')}
                    </Typography>
                )}
            </PriceGuestWrapper>
            <AvailableTag $onRequest={!showCalendar}>
                <TickIcon as={CheckIcon as AnyStyledComponent} alt="tick-icon" />
                <Typography variant="overline" fontWeight="regular" color="white">
                    {showCalendar ? t('available') : t('onRequestTitle')}
                </Typography>
            </AvailableTag>
        </CostBar>
    )
}

export default Costs
